import CondenseIconMark from "./CondenseIconMark";

const DEFAULT_TAGLINE = "Auto-Condense Long Videos";

export default function CondenseLogo({
  height = 36,
  className = "",
  color = "#ffffff",
  accentColor = "#22c55e",
  full = false,
  showWordmark = true,
  tagline = DEFAULT_TAGLINE,
}) {
  const scale = height / 40;
  const iconSize = height * 0.85;

  const lockup = (
    <span
      className={`condense-logo ${className}`}
      style={{ display: "inline-flex", alignItems: "center", gap: 8 * scale }}
    >
      <CondenseIconMark size={iconSize} />
      {showWordmark ? (
        <span
          style={{
            fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
            fontWeight: 700,
            fontSize: height * 0.55,
            letterSpacing: "-0.02em",
            color,
            lineHeight: 1,
            whiteSpace: "nowrap",
          }}
        >
          Condense
        </span>
      ) : null}
    </span>
  );

  if (!full) return lockup;

  return (
    <span
      className={`condense-logo-full ${className}`}
      style={{ display: "inline-flex", flexDirection: "column", alignItems: "flex-start", gap: 4 * scale }}
    >
      {lockup}
      {tagline ? (
        <span
          style={{
            fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
            fontWeight: 500,
            fontSize: height * 0.28,
            letterSpacing: "-0.01em",
            color,
            opacity: 0.85,
            lineHeight: 1.2,
            whiteSpace: "nowrap",
            marginLeft: (iconSize + 8 * scale) * 0.02,
          }}
        >
          {tagline}
        </span>
      ) : null}
    </span>
  );
}
